const postData = [
  {
    postNumber: "1007266741592325",
  },
  {
    postNumber: "1000338355618497",
  },
  {
    postNumber: "1000338348951831",
  },
  {
    postNumber: "999335182385481",
  },
  {
    postNumber: "997221995930133",
  },
  {
    postNumber: "980500184268981",
  },

  {
    postNumber: "979792724339727",
  },
  {
    postNumber: "979792684339731",
  },
  {
    postNumber: "494926909290559",
  },
  {
    postNumber: "491159069869764",
  },
  {
    postNumber: "568598061962221",
  },
  {
    postNumber: "505783058407365",
  },
  {
    postNumber: "502468708738800",
  },
  {
    postNumber: "487487270236944",
  },
  {
    postNumber: "147400488068157",
  },
];
export default postData;
